// extracted by mini-css-extract-plugin
export default {"main":"ad4c1a6637 _216e0400f3","xmark":"_3eff55f1d0","fl_img":"_325cb9779a _665da4f13e"};